<script setup lang="ts">
  defineProps({
    order: { type: Object, required: true },
  });
</script>
<template>
  <div class="summary">
    <div class="summary__content">
      <div class="item">
        <div class="item__property">
          {{ $t('SHOP.ORDER.LABEL.ITEMS_TOTAL') }}
        </div>
        <div class="item__value">
          <SfMoney :code="order.currencyCode" :decimals="order.currency.decimals" :value="order.itemsGross" />
        </div>
      </div>
      <div class="item">
        <div class="item__property">
          {{ $t('SHOP.ORDER.LABEL.SHIPPING_COST') }}
        </div>
        <div class="item__value">
          <SfMoney :code="order.currencyCode" :decimals="order.currency.decimals" :value="order.shippingCost || 0" />
        </div>
      </div>
      <div class="item">
        <div class="item__property">
          {{ $t('SHOP.ORDER.LABEL.DISCOUNT') }}
        </div>
        <div class="item__value">
          <SfMoney :code="order.currencyCode" :decimals="order.currency.decimals" :value="(order.discountGross * -1) || 0" />
        </div>
      </div>
      <div class="item item--final">
        <div class="item__property">
          {{ $t('SHOP.ORDER.LABEL.ORDER_TOTAL') }}
          <span>{{ $t('SHOP.ORDER.LABEL.INCL_VAT') }}</span>
        </div>
        <div class="item__value">
          <SfMoney :code="order.currencyCode" :decimals="order.currency.decimals" :value="order.totalGross" />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .summary {
    display: flex;
    justify-content: flex-end;
    margin-top: 2rem;

    &__content {
      display: flex;
      flex-direction: column;
      gap: 0.375rem;
    }
  }

  .item {
    display: flex;
    justify-content: space-between;
    gap: 2rem;

    &__property {
      font-size: 0.875rem;
      line-height: 1.2rem;
    }

    &__value {
      font-weight: var(--font-weight-bold);
      line-height: 1.2rem;
    }

    &--final {
      .item__property {
        font-weight: var(--font-weight-bold);

        span {
          display: block;
          color: var(--secondary-color);
          font-weight: var(--font-weight-regular);
          font-size: 0.625rem;
        }
      }
    }
  }
</style>
